import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import deleteBin from '../../assets/icons/delete.svg';
import edit from '../../assets/icons/edit.svg';
import styles from './manager.module.css';
import SearchBar from '../../components/SearchBar';
import PrevAndNextBtn from '../../components/PrevAndNextBtn';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { useNavigate } from "react-router-dom";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';

function ManageTable({ list, handleEdit, handleDelete, loading }) {
    return (
        <TableContainer component={Paper} elevation={0}>
            <Table aria-label="hospital table">
                <TableHead>
                    <TableRow sx={{ background: '#c8ebea' }}>
                        <TableCell 
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '60%', paddingLeft: '2.5pc' }}
                        >
                            ชื่อยศ
                        </TableCell> 
                        <TableCell 
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '25%' }} 
                        >
                            ตัวย่อ
                        </TableCell> 
                        <TableCell 
                            className={`${styles.head2Text} ${styles.headTable}`}
                            style={{ width: '15%' }} 
                            align="center"
                        >
                            จัดการ
                        </TableCell> 
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.length === 0 ? (
                        <TableRow>
                            <TableCell 
                                className={styles.head2Text} 
                                colSpan={3} 
                                align="center" 
                                style={{ borderBottom: '1px solid transparent', paddingTop: '5pc' }}
                            >
                                {loading ? 'กำลังโหลดข้อมูล...' : 'ไม่มีข้อมูล'}
                            </TableCell>
                        </TableRow>
                    ) : (
                        list.map((each) => (
                            <TableRow key={each.line_number} sx={{ borderBottom: '1px solid transparent','&:hover': { backgroundColor: '#fafafa'}}}> 
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 8px 10px 40px' }} >
                                    {each.name}
                                </TableCell> 
                                <TableCell className={styles.bodyText} style={{ borderBottom: '1px solid transparent', padding: '10px 8px 10px 15px' }}>
                                    {each.remark}
                                </TableCell>
                                <TableCell style={{ borderBottom: '1px solid transparent', padding: '10px 8px' }} align="center">
                                    <img src={edit} alt="Edit" onClick={() => handleEdit(each.line_number, each.name, each.remark)} className={styles.modifyIcon} />
                                    <img src={deleteBin} alt="Delete" onClick={() => handleDelete(each.line_number, each.name)} className={styles.modifyIcon} />
                                </TableCell>

                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function PositionManager() {   
    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toDelete, setToDelete] = useState({ line_number: null, position_name: null }); // State for the item to delete
    const [showDeleteModal, setShowDeleteModal] = useState(false); // State for modal visibility
    const navigate = useNavigate();

    useEffect(() => {
        fetchPositionData(currentPage,null,null);
    }, []);

    const fetchPositionData = async (page,search) => {
        setLoading(true);
        const res = await api.findPosition(page,search,null);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setFilteredList(detail);
                setTotalPage(res['data']['pagging']['totalPage'])
            } else if ("Not found data." === res['data']['message']) {
                setFilteredList([]);
                setTotalPage(1);
            } else {
                //alert(res['data']['message']);
            }
        } else {
          alert("ไม่ตอบสนอง");
        }
    };

    const handleSearch = () => {
        setCurrentPage(1); 
        fetchPositionData(1,searchQuery)
    };

    const handleEdit = (line_number, position_name, position_name_short) => {
        navigate('/positionEdit', { state: { line_number , position_name, position_name_short } });
    };

    const handleAdd = () => {
        navigate('/positionAdd');
    };

    const handleOrder = () => {
        navigate('/positionOrderEdit');
    };

    const handleDeleteClick = (line_number, position_name) => {
        setToDelete({ line_number, position_name });
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        setLoading(true);
        const res = await api.deletePosition(toDelete.line_number);
        setLoading(false);
        setShowDeleteModal(false);
        if (res) {
            if (res['data']['code'] === 200) {
                if (
                    filteredList.length === 1 &&
                    currentPage === totalPage &&
                    currentPage > 1
                ) {
                    setCurrentPage(currentPage - 1);
                    await fetchPositionData(currentPage - 1, searchQuery);
                } else {
                    await fetchPositionData(currentPage, searchQuery);
                }
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
    };

    const handleNext = async () => {
        if (currentPage < totalPage) {
            const nextPage = currentPage + 1;
            setCurrentPage(nextPage);
            await fetchPositionData(nextPage,searchQuery);
        }
    };    

    const handlePrevious = async () => {
        if (currentPage > 1) {
            const previousPage = currentPage - 1;
            setCurrentPage(previousPage);
            await fetchPositionData(previousPage,searchQuery);
        }
    };    
    
    return (
        <>
            <Loader loading={loading} />
            {showDeleteModal && (
                <CustomizedModal
                    onClose={handleCloseModal}
                    apiCall={confirmDelete}
                    confirmMessage={`ต้องการลบ "${toDelete.position_name}" หรือไม่?`}
                    confirmButtonText={`ยืนยัน`}
                />
            )}
            <Box className={styles.head1Text}>จัดการยศ</Box>
            <Box className={styles.bodyText}>จัดการรายการยศของเจ้าหน้าที่หรือกำลังพล</Box>
            <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box className={styles.head2Text}>ค้นหาชื่อยศ</Box>
                <SearchBar 
                    label="ค้นหาด้วยชื่อ" 
                    searchQuery={searchQuery} 
                    setSearchQuery={setSearchQuery} 
                    handleSearch={handleSearch} 
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1 , marginRight: 1}}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOrder}
                        sx={{ padding: 1, borderRadius: 1.5, marginRight: 1 }}
                    >
                        <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 35px' }}>เรียงลำดับ</p>
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAdd}
                        sx={{ padding: 1, borderRadius: 1.5}}
                    >
                        <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 35px' }}>เพิ่มใหม่</p>
                    </Button>
                </Box>
                <Box sx={{  marginTop: 2, flexGrow: 1, border: '1px solid #aeb4dd', borderRadius: 1, backgroundColor: 'white',position: 'relative',overflow: 'auto' }}>
                    <ManageTable 
                        list={filteredList} 
                        handleEdit={handleEdit} 
                        handleDelete={handleDeleteClick}  
                        loading={loading}
                    />   
                    <Box sx={{ marginRight: 2, marginBottom: 2}}>
                        <PrevAndNextBtn
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    </Box>
                </Box>   
            </Box>
        </>
    );
}
export default PositionManager;
